import * as type from "../../types/API/inventoryApprovalType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getInventoryApprovalReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_INVENTORY_APPROVAL:
      return {
        ...state,
        loading: true,
      };
    case type.GET_INVENTORY_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.data,
        total: action.payload.responseData?.total,
      };
    case type.GET_INVENTORY_APPROVAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const getInventoryApprovalByIdReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_INVENTORY_APPROVAL_BY_ID:
      return {
        ...state,
        loading: true,
      };
    case type.GET_INVENTORY_APPROVAL_BY_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.data,
      };
    case type.GET_INVENTORY_APPROVAL_BY_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const acceptRejectApprovalReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ACCEPT_REJECT_APPROVAL:
      return {
        ...state,
        loading: true,
      };
    case type.ACCEPT_REJECT_APPROVAL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.ACCEPT_REJECT_APPROVAL_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};